import path from 'path'
import fs from 'fs'
import depcheck from 'depcheck'
import packageJson from 'package-json'
import semver from 'semver'
import { readFile } from './utils'
import colors from 'chalk'

/**
 * Checks modules that are outdated
 * 
 * @param {string} pkgPath Adrress for the package.json file
 */
async function getOutdated (pkgPath) {
  return new Promise(async (resolve, reject) => {
    let pkg = await readFile(pkgPath, 'utf-8')
    pkg = JSON.parse(pkg)
    let deps = Object.assign({}, pkg.devDependencies, pkg.dependencies)
    let list = []
    let promiseList = []
    let reports = []
    for (let dep in deps) {
        if (deps[dep].match(/^[\^\~\d]+\.\d+\.\d+/)) {
            // is a valid version number
            promiseList.push(packageJson(dep))
        }
    }
    let remoteDeps
    try {
      remoteDeps = await Promise.all(promiseList)
      remoteDeps.forEach(dep => {
        // let's see if the version fits in the range
        if (semver.satisfies(dep.version, deps[dep.name])
            && semver.intersects(dep.version, deps[dep.name])) {
                list.push(`${colors.bold(dep.name)}: ${colors.red(deps[dep.name])} |-> ${colors.green(dep.version)}`)
        }
      })
    } catch(e) {
      // we will do nothing in case of failure
    }
    resolve(list)
  })
}

/**
 * Will look for modules that are installed but are never used.
 * 
 * @param {string} PROJECT_PATH The path for the project
 * @param {string} configList A list from the configuration refering aliases
 */
async function analyzeDependencies (PROJECT_PATH, configList) {
  let AVAILABLE_ALIASES = {}
  configList.forEach(config => {
    if (config.resolve && config.resolve.alias) {
      AVAILABLE_ALIASES = Object.assign({}, AVAILABLE_ALIASES, config.resolve.alias)
    }
  })

  return new Promise ((resolve, reject) => {
    depcheck(PROJECT_PATH, {
      update: true,
      skipUnused: false,
      directory: PROJECT_PATH,
      parsers: {
        '*.js': depcheck.parser.es6,
        '*.mjs': depcheck.parser.es6,
        '*.jsx': depcheck.parser.jsx
      },
      ignoreMatches: [
        'grunt-*',
        'webpack-*',
        'dist/*',
        '*-loader',
        'eshint',
        'eslint',
        'babel',
        'vue',
        '*.coffee',
        '*.vue',
        '*.ts',
        '*.tsx',
        'preact-compat'
      ],
      detectors: [
        depcheck.detector.requireCallExpression,
        node => {
          if (node.type === 'ImportDeclaration' && node.source && node.source.value) {
            for (let key in AVAILABLE_ALIASES) {
              if (node.source.value.startsWith('.') || node.source.value.startsWith('/')) {
                return []
              }
              if (node.source.value.startsWith(key + '/') || node.source.value === key) {
                let res = node.source.value.replace(key, AVAILABLE_ALIASES[key])
                return [res]
              }
            }
            return [node.source.value]
          }
          return []
        }
      ]
    }, unused => {
      const unusedModules = unused.dependencies.concat(unused.devDependencies)
      resolve({
        unused: unusedModules
      })
    })
  })
}

export {
  analyzeDependencies,
  getOutdated
}



// WEBPACK FOOTER //
// ./src/module-verifier.js